import { useMsal } from '@azure/msal-react';
import { useContext, useEffect, useState } from 'react';

import { TableName } from '../../constants/table';
import TenantContext from '../../lib/context/TenantContext';
import { getEntity } from '../../lib/services/api-service';

const useUserRole = () => {
  const { accounts } = useMsal();
  const { tenant } = useContext(TenantContext);
  const [userRole, setUserRole] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const tenantId = tenant?.id;
        const userEmail = accounts?.[0]?.username.toLowerCase();

        if (tenantId && userEmail) {
          const userEntity = await getEntity(
            TableName.Users,
            tenantId,
            userEmail.toLowerCase()
          );

          if (userEntity && typeof userEntity.Role === 'string') {
            setUserRole(userEntity.Role);
          }
        }
      } catch (error) {
        // Handle error
      }
    };

    fetchUserRole();
  }, [accounts, tenant]);

  return userRole;
};

export default useUserRole;
